//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date :09/01/2025
// Version : 1
// Description : Para asignar los tecnicos (instaladores) pero de instalaciones motivo 19
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date :
// Change by :
// Change description:
//
// Change Date :
// Change by :
// Change description:
//
//========================================================================/
import {
  Dialog,
  Box,
  TextField,
  Grid,
  IconButton,
  Typography,
  Button,
  DialogContent,
  Autocomplete,
  DialogActions,
} from "@mui/material";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import React, { useState, useEffect } from "react";
import { grey } from "@mui/material/colors";
import { UrlApi } from "../../../../services/apirest";
import Notify from "../../../Notify";
import { enviarsms, enviarmails } from "../../../../services/services";
import { logEventos } from "../../../../services/services";

export default function AsignarTecnico2(props) {
  console.log("asignar tecnico 2")
  const { open, setOpen } = props;
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
  const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif
  const [error, setError] = useState(null);
  const [instaladores, setInstaladores] = useState([]);
  const [uniqueInstalador, setUniqueInstalador] = useState(null);

  const [dataReclamo, setDataReclamo] = useState(props.datos);
  const [datosFormulario, setdatosFormulario] = useState({
    id_proveedor: null,
    estado: 170,
  });

  const obtenerInstaladores = () => {
    fetch(UrlApi + "/proveedores/instaladores/")
      .then((data) => data.json())
      .then((data) => setInstaladores(data));
  };

  useEffect(() => {
    obtenerInstaladores();
  }, []);

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const handleGuardarReclamo = async (e) => {
    logEventos(
      `Guardar técnico asignado a reclamo ${props.datos.id_reclamo}`,
      "Reclamos Granel",
      "Se guardo el técnico asignado",
      localStorage.getItem("user"),
    );
    e.preventDefault();
    setDeshabilitado(true);

    const proveedorAnterior = dataReclamo.id_proveedor; // Guardar el proveedor actual (anterior)
    let response = await fetch(
      UrlApi + "/reclamos/update_2/" + props.datos.id_reclamo,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_proveedor: uniqueInstalador.id,
          estado: 170,
        }),
      },
    );
    if (response.ok === false) {
      const error = response && response.json();
      setError(error);
      alert("Inconvenientes con la API. No se pudo guardar. ");
    } else {
      try {
        const json = await response.json();
        if (json.message) {
          if (props.activeTab === 1) {
            if (proveedorAnterior) {
              // Notificar al proveedor anterior que se reasignó la OT
              const mensajeReasignacion = `Hola ${dataReclamo.razon_prov.trim()}, la OT ${
                dataReclamo.id_reclamo
              } cliente ${dataReclamo.id_cliente}-${
                dataReclamo.razon_social
              }.\nInstalación por factibilidad ${
                dataReclamo.id_fact
              }  fue reasignada.`;
              enviarsms(dataReclamo.telefono, mensajeReasignacion);
            }
            // Notificar al proveedor nuevo que se asignó la OT
            const mensajeAsignacion = `Hola ${uniqueInstalador.razon_social.trim()}, se te asignó la OT ${
              dataReclamo.id_reclamo
            } cliente ${dataReclamo.id_cliente}-${
              dataReclamo.razon_social
            }.\nInstalación por factibilidad ${
              dataReclamo.id_fact
            }. Ver en la app.`;
            enviarsms(uniqueInstalador.telefono, mensajeAsignacion);

  //           enviarmails(
  //             uniqueInstalador.email,
  //             `Asignación de OT N° ${dataReclamo.id_reclamo}`,
  //             `<!DOCTYPE html>
  //  <html>
  //    <body style="font-family: Arial, sans-serif; font-size: 14px; color: #333;">
  //      <p>Hola <strong>${uniqueInstalador.razon_social.trim()}</strong>,</p>
  //      <p>Se te ha asignado la Orden de Trabajo N° <strong>${dataReclamo.id_reclamo}</strong>.</p>
  //      <p>Cliente: <strong>${dataReclamo.id_cliente} - ${dataReclamo.razon_social}</strong>.</p>
  //      <p>Instalación por factibilidad: <strong>${dataReclamo.id_fact}</strong>.</p>
  //      <p>Por favor, ingresá a la app para ver los detalles.</p>
  //      <p>Saludos.</p>
  //    </body>
  //  </html>`,
  //           );

      // Enviar mail al técnico asignado
            enviarmails(
              uniqueInstalador.email,
              `Asignación de OT N° ${dataReclamo.id_reclamo}`,
              `<!DOCTYPE html>
     <html>
       <body style="font-family: Arial, sans-serif; font-size: 14px; color: #333;">
         <p>Hola <strong>${uniqueInstalador.razon_social.trim()}</strong>.</p>
         <p>Se te ha asignado la orden de trabajo N° <strong>${dataReclamo.id_reclamo}</strong>. Por favor, ingresá a la app para ver los detalles, saludos.
       </body>
     </html>`,
            );

            setNotificacion(true);
            setOpenSnack(true);
            setMensaje(
              json.message === "OK"
                ? "Guardado"
                : "Guardado. Actualizar RTA Api.",
            );

            props.actualizar();
          } else {
            if (proveedorAnterior) {
              // Notificar al proveedor anterior que se reasignó la OT
              const mensajeReasignacion = `Hola ${dataReclamo.razon_prov.trim()}, la OT ${
                dataReclamo.id_reclamo
              } fue reasignada.`;
              enviarsms(dataReclamo.telefono, mensajeReasignacion);
            }

            // Notificar al proveedor nuevo que se asignó la OT
            const mensajeAsignacion = `Hola ${uniqueInstalador.razon_social.trim()}, se te asignó la OT ${
              dataReclamo.id_reclamo
            }. Ver en la app.`;
            enviarsms(uniqueInstalador.telefono, mensajeAsignacion);

  //           enviarmails(
  //             uniqueInstalador.email,
  //             `Asignación de OT N° ${dataReclamo.id_reclamo}`,
  //             `<!DOCTYPE html>
  //  <html>
  //    <body style="font-family: Arial, sans-serif; font-size: 14px; color: #333;">
  //      <p>Hola <strong>${uniqueInstalador.razon_social.trim()}</strong>,</p>
  //      <p>Se te ha asignado la Orden de Trabajo N° <strong>${dataReclamo.id_reclamo}</strong>.</p>
  //      <p>Cliente: <strong>${dataReclamo.id_cliente} - ${dataReclamo.razon_social}</strong>.</p>
  //      <p>Instalación por factibilidad: <strong>${dataReclamo.id_fact}</strong>.</p>
  //      <p>Por favor, ingresá a la app para ver los detalles.</p>
  //      <p>Saludos.</p>
  //    </body>
  //  </html>`,
  //           );

      // Enviar mail al técnico asignado
            enviarmails(
              uniqueInstalador.email,
              `Asignación de OT N° ${dataReclamo.id_reclamo}`,
              `<!DOCTYPE html>
     <html>
       <body style="font-family: Arial, sans-serif; font-size: 14px; color: #333;">
         <p>Hola <strong>${uniqueInstalador.razon_social.trim()}</strong>.</p>
         <p>Se te ha asignado la orden de trabajo N° <strong>${dataReclamo.id_reclamo}</strong>. Por favor, ingresá a la app para ver los detalles, saludos.
       </body>
     </html>`,
            );

            setNotificacion(true);
            setOpenSnack(true);
            setMensaje(
              json.message === "OK"
                ? "Guardado"
                : "Guardado. Actualizar RTA Api.",
            );
            props.actualizar();
          }
        } else if (json.sqlMessage) {
          json && setError(json);
          alert("SQL erróneo (" + json.code + " Errno: " + json.errno + " )");
        } else {
          alert("ERROR DESCONOCIDO.");
        }
      } catch (error) {
        if (error.toString().includes("is not valid JSON")) {
          setNotificacion(true);
          setOpenSnack(true);
          setMensaje("Guardado");
          props.actualizar();
        } else {
          alert("Error: " + error);
        }
      }
    }
  };

  const handleClose = () => {
    props.tabla(true);
    setOpen(false); // Cierra el diálogo notificando al padre
  };

  const [deshabilitado, setDeshabilitado] = useState(false);

  useEffect(() => {
    setDeshabilitado(!uniqueInstalador);
  }, [uniqueInstalador]);

  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
          },
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container backgroundColor="#1F618D" p={1.5}>
            <Grid item xs={2}>
              <IconButton onClick={() => setOpen(false)} sx={{ color: "#fff" }}>
                <ArrowBackIcon />
              </IconButton>
            </Grid>

            <Grid
              item
              xs={8}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="h5" color="#ffffff">
                Asignar Técnico
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <DialogContent>
          <Box
            backgroundColor="#F4F6F6"
            mt={2}
            mb={2}
            ml={3}
            p={3}
            border={0.5}
            borderColor={"#ABB2B9"}
            borderRadius={4}
          >
            <Grid container spacing={1} direction={{ xs: "column", sm: "row" }}>
              <Grid item xs={12}>
                <Autocomplete
                  style={style}
                  noOptionsText={"Instalador INEXISTENTE"}
                  options={instaladores || []}
                  autoHighlight
                  disableClearable
                  getOptionLabel={(instaladores) => instaladores.razon_social}
                  onChange={(event, value) => setUniqueInstalador(value)}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.razon_social}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.razon_social}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      fullWidth={true}
                      placeholder="Tipee para buscar un instalador.."
                      {...params}
                      variant="outlined"
                      label="Instalador "
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-end"
            mt={0}
          >
            <Button
              disabled={deshabilitado}
              variant="contained"
              type="submit"
              color="success"
              size="small"
              onClick={handleGuardarReclamo}
            >
              Asignar Técnico
            </Button>
          </Grid>
        </DialogActions>
        {notificacion ? (
          <Notify
            mensaje={mensaje}
            open={openSnack}
            color={"#D4EFDF"}
            severity={"success"}
            handleClose={handleClose}
            error={error}
          />
        ) : null}
      </Dialog>
    </div>
  );
}
